var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("messages.title")))]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.messageType,
            callback: function($$v) {
              _vm.messageType = $$v
            },
            expression: "messageType"
          }
        },
        [
          _c("el-tab-pane", {
            attrs: { label: _vm.$t("messages.inbox"), name: "IN" }
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: _vm.$t("messages.draft"), name: "OUT" }
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: _vm.$t("messages.archived"), name: "ARCHIVE" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "messages-table" },
        [_c("messages-table")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }